import PayrollGroupsPage from './PayrollGroupsPage';
export default PayrollGroupsPage;